import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

constructor() { }

public showNotification( type: string, message: string ): void {
  // this.notifier.notify( type, message );
}

/**
 * Hide oldest notification
 */
public hideOldestNotification(): void {
  // this.notifier.hideOldest();
}

/**
 * Hide newest notification
 */
public hideNewestNotification(): void {
  // this.notifier.hideNewest();
}

/**
 * Hide all notifications at once
 */
public hideAllNotifications(): void {
  // this.notifier.hideAll();
}

}
